import { DEFAULT_LOGIN_TYPE, LOGIN_TYPE, LOGIN_TYPE_VALUES } from './constants'
import { isMobile } from '@/utils/viewport'

/** @param {string} [ua] */
export function isWechatBrowser (ua = typeof navigator !== 'undefined' ? navigator.userAgent : '') {
  return /micromessenger/i.test(ua)
}

/** @param {string|number|null|undefined} type */
export function normalizeLoginType (type) {
  const normalizedType = String(type ?? '')
  if (LOGIN_TYPE_VALUES.includes(normalizedType)) {
    return normalizedType
  }
  return DEFAULT_LOGIN_TYPE
}

/**
 * 按环境解析默认登录 Tab（URL loginType 优先）
 * @param {{ loginType?: string, isWechat?: boolean, isMobileDevice?: boolean }} options
 */
export function resolveDefaultLoginType ({
  loginType = '',
  isWechat = isWechatBrowser(),
  isMobileDevice = isMobile()
} = {}) {
  const routeLoginType = String(loginType ?? '')
  if (LOGIN_TYPE_VALUES.includes(routeLoginType)) {
    const normalized = normalizeLoginType(routeLoginType)
    if (isWechat && normalized === LOGIN_TYPE.QRCODE) {
      return LOGIN_TYPE.OAUTH
    }
    return normalized
  }
  if (isWechat) return LOGIN_TYPE.OAUTH
  if (isMobileDevice) return LOGIN_TYPE.SMS
  return LOGIN_TYPE.QRCODE
}

/** @param {boolean} isWechat */
export function buildVisibleLoginTabs (isWechat) {
  return [
    ...(isWechat
      ? [{ key: LOGIN_TYPE.OAUTH, name: '授权登录' }]
      : [{ key: LOGIN_TYPE.QRCODE, name: '扫码登录' }]),
    { key: LOGIN_TYPE.SMS, name: '验证码登录' },
    { key: LOGIN_TYPE.PASSWORD, name: '密码登录' }
  ]
}
